const current = () =>
  window.innerWidth >= window.innerHeight ? "LANDSCAPE" : "PORTRAIT";

export default {
  lockToLandscape() {},
  lockToPortrait() {},
  unlockAllOrientations() {},
  getInitialOrientation: current,
  getOrientation(cb) {
    cb(null, current());
  },
  addOrientationListener() {},
  removeOrientationListener() {},
};
